import React from "react";
import { NavLink } from "react-router-dom";
import { SEASON_OPTIONS } from "@/lib/sports";

// Sub-navigation shared by the sports section so both Teams and Standings are
// reachable on every viewport (incl. mobile, where the bottom bar is limited).
export function SportsNav() {
  const tabs = [
    { to: "/teams", label: "Teams", testid: "sports-tab-teams" },
    { to: "/standings", label: "Standings", testid: "sports-tab-standings" },
  ];
  return (
    <div className="flex items-center gap-1 mb-5 border-b border-[#2A3544]" data-testid="sports-nav">
      {tabs.map((t) => (
        <NavLink key={t.to} to={t.to} data-testid={t.testid}
          className={({ isActive }) => `px-4 h-10 text-sm font-display tracking-wide border-b-2 -mb-px transition-colors ${isActive ? "border-[#2F7D32] text-white" : "border-transparent text-white/50 hover:text-white"}`}>
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}

export function LeagueToggle({ value, onChange, leagues = ["NFL", "NCAA"] }) {
  return (
    <div className="flex items-center gap-2" data-testid="league-toggle">
      {leagues.map((l) => (
        <button key={l} onClick={() => onChange(l)} data-testid={`league-${l}`}
          className={`px-4 h-9 rounded-full text-sm font-display tracking-wide transition-colors ${value === l ? "bg-[#2F7D32] text-white" : "tt-panel text-white/60 hover:text-white"}`}>
          {l}
        </button>
      ))}
    </div>
  );
}

export function SeasonSelect({ value, onChange }) {
  return (
    <label className="inline-flex items-center gap-2 text-sm text-white/50" data-testid="season-select-wrap">
      <span className="hidden sm:inline">Season</span>
      <select value={value} onChange={(e) => onChange(Number(e.target.value))} data-testid="season-select"
        className="h-9 rounded-lg bg-[#131a24] border border-[#2A3544] px-3 text-white text-sm focus:border-[#2F7D32] outline-none">
        {SEASON_OPTIONS.map((s) => <option key={s} value={s}>{s}</option>)}
      </select>
    </label>
  );
}
